<template>
  <div class="page-stay-pop" id="page-stay-pop" v-show="popShow">
    <div class="bg" id="bg"></div>
    <div class="card">
        <div class="header">
            <p class="title">{{ title || $t('GDriver_Rwards_EXVw_LGRt') }}</p>
            <img @click="closePop" class="pop-close" src="https://s3-us01.didiglobal.com/silver-bullet-img/2022-08-02/sBs4lwO9uQ9y73BskeNZA-icon_close_2x.png" alt="">
        </div>
        <slot></slot>
    </div>
  </div>
</template>
<script>
import { BRAND_NAME_MAP } from "../../../tools/constant";
export default {
  data() {
    return {
      popShow: false,
    };
  },
  props: {
    
    title: {
      type: String,
      default: '',
    },
    ignoreDay: {
      // true：展示到小时；false：展示到天
      type: Boolean,
      default: true,
    },
  },
  computed: {
    country() {
      const params = new URLSearchParams(location.search);
      return params.get("location_country");
    },
    pic_desc() {
      return this.formItem.pic_desc || {};
    },
  },
  // mounted() {
  //   console.log(11111);
  // },
  methods: {
    
    closePop() {
      this.popShow = false;
      
    },
  },
};
</script>
<style lang="scss" scoped>
.page-stay-pop {
  position: fixed;
  left: 0;
  top: 0;
  z-index: 999999;
  /* transform:  translateY(100%); */
  height: 100vh;
  width: 100vw;
  .bg {
    position: absolute;
    height: 100%;
    width: 100%;
    overflow: hidden;
    opacity: 0.6;
    background: #0f1928;
  }
  .card {
    position: absolute;
    left: 0;
    bottom: 0;
    width: 100%;
    height: 73%;
    // padding-bottom: 1.7rem;
    box-sizing: border-box;
    border-radius: 0.4rem 0.4rem 0 0;
    background: #F5F5F7;
    .header {
      min-height: 1.2rem;
      
    }
    .pop-close {
      position: absolute;
      right: 0.36rem;
      top: 0.36rem;
      width: 0.48rem;
    }
    .title {
      padding: 0.33rem;
      font-size: 0.4rem;
      font-weight: bold;
      color: #333333;
    }
    .desc {
      padding: 0.05rem 0.33rem 0.33rem 0.33rem;
      font-size: 0.32rem;
      color: #666666;
      letter-spacing: 0;
      line-height: 0.38rem;
      ::v-deep a {
        font-size: 0.32rem;
        font-weight: 500;
        color: #ff7226;
      }
    }
    .btns {
      // position: absolute;
      // bottom: 0;
      width: 100%;
      box-sizing: border-box;
      padding: 0.32rem;
      font-size: 0.36rem;
      color: #ffffff;
      .btn {
        text-align: center;
      }
      .yes {
        height: 1.08rem;
        line-height: 1.08rem;
        font-weight: 700;
        background: #ff7226;
        border-radius: 0.12rem;
      }
      .no {
        margin-top: 0.32rem;
        font-size: 0.32rem;
        font-weight: 500;
        color: #666;
      }
    }
  }
}
</style>
